import { ICardType } from "../types/cardType";
import { formatPrice } from "../helpers/siteHelpers";

const Card: React.FC<ICardType> = ({ data, referer, isMobile }) => {
  let highlights = data.DDHighlights;
  if (data.DDHighlights && typeof data.DDHighlights === "string") {
    highlights = data.DDHighlights.split("~");
  }
  const site = referer === "uk" ? "com" : "ie";

  let showHighlights = true;
  if (
    data.ConvertedSupplierName === "explore" ||
    data.ConvertedSupplierName === "gadventures" ||
    data.ConvertedSupplierName === "intrepidtravel"
  )
    showHighlights = false;


    // PRICE FORMATTING
  let guidePrice;
  if (referer === "uk" && data.DDGBP !== "Please contact us") {
    guidePrice = (
      <h6 className="d-inline-block text-dark text-strong pt-3">
        Guide Price: £{formatPrice(data.DDGBP)}
      </h6>
    );
  } else if (referer === "ie" && data.DDEUR !== "Please contact us") {
    guidePrice = (
      <h6 className="d-inline-block text-dark text-strong pt-3">
        Guide Price: €{formatPrice(data.DDEUR)}
      </h6>
    );
  } else {
    guidePrice = (
      <h6 className="d-inline-block text-dark text-strong pt-3">
        Call for latest price
      </h6>
    );
  }

  return (
    <div className="col-12 col-md-6 col-lg-4 mx-auto p-3">
      <div className="card rounded-0 border-0 shadow h-100 p-0">
        <div className="card-img">
          <a href={data.DDLink}>
            <figure className="figure has-object-fit h-15rem">
              <img
                data-object-fit="cover"
                className="img-fluid lazy"
                src="https://cdn.trailfinders.com/static/graphics/spacer.gif"
                data-src={data.DDImage + "?width=480"}
                alt={data.DDTourName}
                title="Barrier Reef Roaming"
              />
            </figure>
          </a>
        </div>
        <div className="card-body py-0">
          <a className="text-dark" href={data.DDLink}>
            <div className="item-header mb-3">
              <h5 className="item-heading text-strong"> {data.DDTourName}</h5>
              <br />
              <small className="d-inline-block">
                <span>Location:</span>
                <span className="text-strong"> {data.DDStartPoint}</span>
              </small>
              <br />
              <small className="d-inline-block">
                <span>Duration:</span>
                <span className="text-strong"> {data.DDDuration}</span>
              </small>
              <br />
              {guidePrice}
            </div>
            <div>
              {showHighlights && highlights && Array.isArray(highlights) && (
                <ul className="text-start">
                  {highlights.map((highlight: string, index: number) => {
                    if (highlight.length > 1) {
                      // this prevents empty list items where user inputs an extra character to split array
                      if (index < 2) {
                        return <li key={`highlight-${index}`}>{highlight}</li>;
                      }
                      if (index === 2) return "...";
                    }
                  })}
                </ul>
              )}

              {!showHighlights && (
                <p className="fw-lighter py-4">
                  {data.Introduction_txt.split(".")[0] + "."}
                </p>
              )}
            </div>
          </a>
        </div>
        <div className="card-footer border-0 bg-white d-flex justify-content-between pb-3">
          <div className="panel-footer-inner has-arrow has-arrow-md d-flex align-items-center">
            <span className="text-strong text-muted">
              <span className="d-flex align-items-center">
                <i className="icon-local_tour me-2 glyph-md"></i>
                <small>{data.DDTourType}</small>
              </span>
            </span>
          </div>

          <div className="dropdown float-end">
            <span
              className="text-secondary d-flex align-items-center dropdown-toggle hover"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <p className="mb-0 me-2">Share</p>
              <i className="icon-chevron_down glyph-sm text-secondary"></i>
            </span>
            <ul className="dropdown-menu">
              <li>
                <a
                  className="dropdown-item"
                  href={`https://www.facebook.com/sharer/sharer.php?u=https://www.trailfinders.${site}${data.DDLink}`}
                >
                  <i className="icon-facebook_share me-2"></i>Facebook
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  href={
                    isMobile
                      ? `https//api.whatsapp.com/send?text=https://www.trailfinders.${site}${data.DDLink}`
                      : `https://web.whatsapp.com/send?text=https://www.trailfinders.${site}${data.DDLink}`
                  }
                >
                  <i className="icon-whatsapp_share me-2"></i>Whatsapp
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  href={`mailto:?subject=${data.DDTourName}&body=Check out this holiday idea. https://www.trailfinders.${site}${data.DDLink}`}
                >
                  <i className="icon-email_share me-2"></i>Email
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Card;
